import { gql } from '@apollo/client';

export const DELETE_NOTIFICATION_MUTATION = gql`
    mutation deleteNotification($input: DeleteNotificationInput!) {
        result: deleteNotification(input: $input) {
            affectedRows
        }
    } 
`;
